var _rect, _rect2, _g, _rect3, _polygon, _polygon2, _rect4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNewMountArc(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "411px",
    height: "514px",
    viewBox: "0 0 411 514",
    enableBackground: "new 0 0 411 514",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0.2,
    fill: "#FFFFFF",
    width: 411,
    height: 513.6
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 44.8,
    y: 31.1,
    opacity: 0.8,
    fill: "#DCDCDC",
    width: 321.4,
    height: 375.3
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 65.4,
    y: 78.9,
    fill: "none",
    stroke: "#616261",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    width: 280.2,
    height: 389
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88.5,
    y: 101.9,
    fill: "none",
    stroke: "#616261",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    width: 234,
    height: 342.8
  })))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 348.3,
    y: 133.9,
    fill: "#474746",
    width: 0,
    height: 26
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#B2B2B2",
    stroke: "#717070",
    strokeWidth: 0.6357,
    strokeMiterlimit: 10,
    enableBackground: "new    ",
    points: " 44.8,42 44.9,32.4 0,32.4 12.3,42 44.7,42 "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#B2B2B2",
    stroke: "#717070",
    strokeWidth: 0.6357,
    strokeMiterlimit: 10,
    enableBackground: "new    ",
    points: " 366.3,42.2 398.7,42.2 411,32.6 366.1,32.6 366.2,42.2 "
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    fill: "#C6C6C6",
    stroke: "#717070",
    strokeWidth: 0.5732,
    strokeMiterlimit: 10,
    enableBackground: "new    ",
    width: 411,
    height: 32.1
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewMountArc);
export default __webpack_public_path__ + "static/media/new_mount_arc.62d33ac1bfdce8d1cc39ac5a9ccfecf9.svg";
export { ForwardRef as ReactComponent };